// 主题包（ThemePack）—— 让「换一套素材就像换了一个游戏」成为一等公民。
//
// 核心约定：棋盘逻辑只认 Kind（数字），主题包负责把每个 Kind 渲染成具体美术。
// tiles 数组的下标 = Kind。因此：
//   - 换 emoji → 水果变宝石变动物
//   - 换贴图/图集 → 变成完全自定义的美术风格
//   - 逻辑内核一行都不用改。

/** 单个方块的视觉定义。三种渲染策略择一（优先级：texture > emoji > shape）。 */
export interface TileVisual {
  /** 稳定的可读 id，仅用于调试/清单，不参与匹配逻辑。 */
  id: string;
  /** 策略一：emoji / 任意文字字形。最省事，无需加载资源。 */
  emoji?: string;
  /** 策略二：贴图 URL（相对 public/ 或可被 Pixi Assets 解析的地址）。 */
  texture?: string;
  /** 策略三：程序化色块（无美术资源时的兜底），配合 tint 生成纯色圆角块。 */
  shape?: "circle" | "rounded";
  /** 主色调，用于色块填充、消除粒子与光束的着色。 */
  tint?: number;
}

/** 一套完整的美术皮肤。 */
export interface ThemePack {
  /** 唯一标识，用于选择/持久化。 */
  id: string;
  /** 展示名。 */
  name: string;
  /** 一句话描述。 */
  description?: string;

  /** 方块视觉表，下标即 Kind。数量决定本主题最多支持多少种方块。 */
  tiles: TileVisual[];

  /** 舞台背景色。 */
  background?: number;
  /** 棋盘底板颜色。 */
  boardColor?: number;
  /** 空格子颜色。 */
  emptyCellColor?: number;
  /** 方块底板颜色（emoji / 文字策略下的卡片背景）。 */
  tileCardColor?: number;
  /** 消除光束颜色。 */
  beamColor?: number;
}

/** 主题包能提供的最大方块种类数 —— 关卡曲线用它来封顶 typeCount。 */
export function maxKinds(pack: ThemePack): number {
  return pack.tiles.length;
}

/** 取某个 Kind 的视觉；越界时对贴图数量取模，保证永不崩。 */
export function tileVisual(pack: ThemePack, kind: number): TileVisual {
  return pack.tiles[kind % pack.tiles.length];
}
